import * as Actions from "../../ApiCallStatus/Actions/action";
import { Constant } from "../../../Constants/constant";
import { GetCrewListing } from "../Actions/action";
import { FETCH } from "../../../Services/fetch";
export function getCrewRotationListing() {
    return async (dispatch) => {
        dispatch(Actions.ApiRequestedAction({ apiCallFor: "getCrewRotationListing" }));
        let myJson = await FETCH("GET", Constant.apiURl + "/cms/region");
        if (myJson && myJson.code === 201) {
            dispatch(GetCrewListing(myJson.data))
            dispatch(
                Actions.ApiFulfilledAction({
                    apiCallFor: "getCrewRotationListing",
                    message: myJson.message,
                }))
        }
        else {
            dispatch(Actions.ApiRejectedAction({ statusCode: myJson.statusCode, apiCallFor: "getCrewRotationListing", message: myJson.message }))
        }
    };
}